import type { StateWithSinatra } from '../types';

export const selectUser = (state: StateWithSinatra) => state.sinatra.user;

export const selectUserPermissions = (state: StateWithSinatra) =>
  state.sinatra.user?.currentRole?.permissions || [];

/**
 * Non-hook counterpart to `useCurrentOrg`. Not memoized: it reads a primitive,
 * so there is nothing to derive and no reference to keep stable.
 */
export const selectCurrentOrgId = (state: StateWithSinatra) =>
  state?.sinatra?.user?.currentOrg?.id;
